export class Pagination {
	constructor (
		public pageSize: number = 10,
		public page: number = 0,
		public totalPages: number = 1,
		public totalData: number = 0
	) { }
}